module.exports = {"events":[{"name":"Live Event (in-person)","value":"Event"},{"name":"Live Stream Only","value":"Live Stream"},{"name":"Scheduled Content","value":"Scheduled Content"},{"name":"Video on Demand","value":"Video On Demand"},{"name":"Fee","value":"Fee"},{"name":"Merchandise","value":"Merchandise"},{"name":"Trip","value":"Trip"},{"name":"Donation","value":"Donation"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/EventOptions/locales/en.json
// module id = 1635
// module chunks = 0